export default {
  API_ENDPOINT: 'https://blooming-reef-26525.herokuapp.com',
  TOKEN_KEY: 'Linus-Token-Key',
  ID_KEY: 'user_id'
}
